import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

export interface IErrorMessage {
  message: string;
  cause?: string;
}

export interface IErrorDetails {
  title: string;
  message: string;
  cause?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorNotificationService {
  private errorSubject = new Subject<IErrorDetails>();
  public errors = this.errorSubject.asObservable();

  error(title: string, message: string | IErrorMessage | HttpErrorResponse | any): void {
    const caption = title ? title : 'An error occurred';      // TODO: get rid of title?

    console.log('KPDR error', message);

    let msg = '';
    let theCause;
    if (typeof message === 'string') {
      msg = message;
    } else if (message instanceof HttpErrorResponse) {
      if (message.error) {
        if (message.error.error)
          msg = `${message.error.error}: ${message.error.message}`;
        else
          msg = message.message;

        if (message.error.message)
          theCause = message.error.message;
      } else {
        msg = message.message;
      }
    } else {
      msg = message.message;
      theCause = message.cause;
    }

    this.errorSubject.next({title: caption, message: msg, cause: theCause});
  }
}
